import React, { useState } from 'react';
import apiService from '../api/apiService';
import './Notifications.css';

const TARGET_OPTIONS = [
  { value: 'all', label: 'All (broadcast)' },
  { value: 'distributors', label: 'Distributors only' },
  { value: 'users', label: 'Users only' },
];

const Notifications: React.FC = () => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [target, setTarget] = useState('all');
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !body.trim()) {
      setMessage('Title and body are required.');
      setIsError(true);
      return;
    }
    setSending(true);
    setMessage('');
    setIsError(false);
    try {
      const { data } = await apiService.post('/admin/notifications/broadcast', { title, body, target });
      const total = data.total_recipients ?? 0;
      const sent = data.sent_count ?? 0;
      const failed = data.failed_count ?? 0;
      if (total === 0) {
        setMessage('Broadcast sent via FCM. No registered devices for this audience yet.');
      } else {
        setMessage(`Sent via FCM to ${total} recipient(s). Delivered: ${sent}${failed > 0 ? `, failed: ${failed}` : ''}.`);
      }
      setIsError(false);
      setTitle('');
      setBody('');
    } catch (err: any) {
      setMessage(err.response?.data?.detail || 'Failed to send.');
      setIsError(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="notifications-page">
      <div className="notifications-card">
        <div className="notifications-header">
          <div className="notifications-icon-wrap">🔔</div>
          <h1>Send notification</h1>
          <p>Broadcast to all, distributors only, or users only</p>
        </div>
        <form className="notifications-form" onSubmit={handleSend}>
          <label>Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="notifications-input"
            placeholder="Notification title"
            required
          />
          <label>Message</label>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            className="notifications-textarea"
            placeholder="Message body"
            required
          />
          <label className="notifications-target-label">Target audience</label>
          <div className="notifications-target-options">
            {TARGET_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                type="button"
                className={`notifications-target-option ${target === opt.value ? 'active' : ''}`}
                onClick={() => setTarget(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </div>
          <button type="submit" disabled={sending} className="notifications-submit">
            {sending ? 'Sending...' : 'Send notification'}
          </button>
        </form>
        {message && (
          <div className={`notifications-message ${isError ? 'error' : 'success'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default Notifications;
